import { FaultTolerance, InvalidParametersError } from '@libp2p/interface';
import { dnsaddrResolver } from '@multiformats/multiaddr/resolvers';
import mergeOptions from 'merge-options';
const DefaultConfig = {
    addresses: {
        listen: [],
        announce: [],
        noAnnounce: [],
        announceFilter: (multiaddrs) => multiaddrs
    },
    connectionManager: {
        resolvers: {
            dnsaddr: dnsaddrResolver
        }
    },
    transportManager: {
        faultTolerance: FaultTolerance.FATAL_ALL
    }
};
export async function validateConfig(opts) {
    const resultingOptions = mergeOptions(DefaultConfig, opts);
    if (resultingOptions.connectionProtector === null && globalThis.process?.env?.LIBP2P_FORCE_PNET != null) { // eslint-disable-line no-undef
        throw new InvalidParametersError('Private network is enforced, but no protector was provided');
    }
    return resultingOptions;
}
//# sourceMappingURL=config.js.map